import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 569.1 115.7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".cls-2{fill:currentColor}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M122.5 50.6H73.9L102.7.7H85.8L61.2 43.3 36.6.7H19.8l28.8 49.9H0v14.6h48.6l-28.8 49.9h16.8l24.6-42.6 24.6 42.6h16.8L73.8 65.2h48.6V50.6zM73.1 64.8l-11.9 6.8-11.9-6.8V51.1l11.9-6.8 11.9 6.8z",
      style: {"fill-rule":"evenodd","fill":"currentColor"}
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "m220.6.7-26 101.3h-8.8L159.8.7h-15l29.7 114.4h31.4L235.6.7zm90.7 73 11-10.9v-49L309.2.7h-65.4v114.4h14.7V75.9h38.4l18.5 39.2h15.9l-19.9-41.4zm-3.8-10.9h-49v-49h49zm83.9-49.7V0l-27.8 1.3L335.8 0v13.1l20.4.8v87.9l-20.4.8v13.1l27.8-1.3 27.8 1.3v-13.1l-20.4-.8V13.9zm82 .7V.7H401v114.4h14.7V75.9h54.4V62.8h-54.4V13.7h57.7zM554 .7l-15.95 62.1h-28.91L493.2.7h-15l15.3 58.8 4.26 16.4h18.54v39.2H531V75.9h18.54l4.26-16.4L569.1.7z",
      class: "cls-2"
    }, null, -1))
  ]))
}
export default { render: render }